import { useBuildex } from '@/hooks/use-buildex/index';
import { features as featureConstant } from '@/utils/feature-verifier';

const redirectGuard = (meta) => meta.dispatch(redirectGuardAction(meta));

const redirectGuardAction = (_to) => (_dispatch, getState) => {

	const state = getState();

	if (state.auth.loggedIn) {

		const features = state.auth.features;
		const hasSubmittals = Array.isArray(features) && features.includes(featureConstant.SUBMITTALS);

		// Honor authGuard's `?returnUrl=` deep-link param when the user has the
		// SUBMITTALS feature; otherwise fall through to the default landing.
		const search = typeof window !== 'undefined' ? window.location.search : '';
		const returnUrl = new URLSearchParams(search).get('returnUrl');
		if (returnUrl && hasSubmittals) return returnUrl;

		const isBuildex = useBuildex();
		const dashboard  = state?.auth?.profile?.dashboard
		const isSupersetDashboard = Array.isArray(features) && features.includes(featureConstant.DASHBOARD);
		const isEmbedDashboard = Array.isArray(features) && features.includes(featureConstant.DASHBOARD_EMBEDDING)
		if(isEmbedDashboard){
			return isBuildex && isSupersetDashboard && dashboard?.length>0? `/dashboard/${dashboard[0].id}` :`/shared-data`
		}
		return isBuildex && isSupersetDashboard ? '/dashboard' : '/shared-data';
	}

	return null
}

export { redirectGuard };
